module.exports = __webpack_public_path__ + "img/traffic.5f6eb6cb.png";